import { ClickSeriesPoint } from '@/services/dashboard/conversionAnalytics/conversionAnalytics.types';

const getTimeInMinutes = (time: string): number => {
  const [hours = 0, minutes = 0] = time.split(':').map(Number);
  return hours * 60 + minutes;
};

export const getVisibleClickData = (clickData: ClickSeriesPoint[], currentDate = new Date()): ClickSeriesPoint[] => {
  const firstDataIndex = clickData.findIndex(({ value }) => value > 0);
  if (firstDataIndex === -1) return [];

  const firstDataHour = Math.floor(getTimeInMinutes(clickData[firstDataIndex].time) / 60);
  const startHourInMinutes = firstDataHour * 60;
  const startHour = `${String(firstDataHour).padStart(2, '0')}:00`;
  const visibleStartIndex = clickData.findIndex(({ time }) => getTimeInMinutes(time) >= startHourInMinutes);
  const currentTimeInMinutes = currentDate.getHours() * 60 + currentDate.getMinutes();
  const nextHourInMinutes = (Math.floor(currentTimeInMinutes / 60) + 1) * 60;
  let visibleEndIndex = -1;

  clickData.forEach(({ time }, index) => {
    if (getTimeInMinutes(time) <= nextHourInMinutes) visibleEndIndex = index;
  });

  if (visibleEndIndex < visibleStartIndex) return [];

  const visibleData = clickData.slice(visibleStartIndex, visibleEndIndex + 1);
  if (visibleData[0]?.time !== startHour) visibleData.unshift({ time: startHour, value: 0 });

  return visibleData;
};
